module.exports = __webpack_public_path__ + "static/media/swap.fdd78fec.svg";